import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'homeToDoActivitiesCard.title',
    defaultMessage: 'Attività da completare',
  },
  questionnaireAMLandFATCA: {
    id: 'homeToDoActivitiesCard.questionnaireAMLandFATCA',
    defaultMessage: 'Questionario AML e FACTA/CRS',
  },
  questionnaireMIFID: {
    id: 'homeToDoActivitiesCard.questionnaireMIFID',
    defaultMessage: 'Questionario MIFID',
  },
  uploadSpecimenTitle: {
    id: 'homeToDoActivitiesCard.uploadSpecimenTitle',
    defaultMessage: 'Specimen di firma',
  },
  notFillable: {
    id: 'homeToDoActivitiesCard.notFillable',
    defaultMessage: 'Non compilabile',
  },
  toComplete: {
    id: 'homeToDoActivitiesCard.toComplete',
    defaultMessage: 'Da completare',
  },
  completed: {
    id: 'homeToDoActivitiesCard.completed',
    defaultMessage: 'Completato',
  },
  goToQuestionnaire: {
    id: 'homeToDoActivitiesCard.goToQuestionnaire',
    defaultMessage: 'Vai al questionario',
  },
  uploadSpecimen: {
    id: 'homeToDoActivitiesCard.uploadSpecimen',
    defaultMessage: 'Carica specimen',
  },
  noSignature: {
    id: 'homeToDoActivitiesCard.noSignature',
    defaultMessage:
      'Firma non ancora disponibile, documenti in fase di caricamento.',
  },
  sign: {
    id: 'homeToDoActivitiesCard.sign',
    defaultMessage: 'Firma',
  },
  goToSign: {
    id: 'homeToDoActivitiesCard.goToSign',
    defaultMessage: 'Vai in area firma',
  },
});
